import T from "prop-types";
import {
  EXCHANGE_SALE,
  EXCHANGE_SPECIAL_INSTRUCTIONS,
  FLAT_EXCHANGE,
  REPAIR_ADMIN_CHARGE_TYPE,
  REPAIR_ADMINISTRATION_CHARGE_DOLLARS,
  REPAIR_ADMINISTRATION_CHARGE_PERCENTAGE,
  SPECIAL_INSTRUCTIONS
} from "MODULES/SalesOrders/constants";
import { INVENTORY_ID, QUANTITY } from "APP_ROOT/constants";
import { CONDITION, LEAD_TIME } from "MODULES/inventories/constants";
import { PRICE_PER_UNIT } from "MODULES/OutgoingQuotes/constants";
import { HAZMAT } from "MODULES/parts/constants";
import { AMOUNT_PAID } from "MODULES/PurchaseOrders/constants";

export const fields = [
  AMOUNT_PAID,
  INVENTORY_ID,
  "sell_as_alt_id",
  CONDITION,
  LEAD_TIME,
  PRICE_PER_UNIT,
  QUANTITY,
  HAZMAT,
  "bio_hazmat",
  "cancellation_reason",
  "customer_qc_preapproval_required",
  EXCHANGE_SALE,
  EXCHANGE_SPECIAL_INSTRUCTIONS,
  FLAT_EXCHANGE,
  SPECIAL_INSTRUCTIONS,
  "core_due_days",
  "core_return_date",
  "core_return_due_date",
  "core_repair_charges",
  "repair_fee",
  "exchange_fee",
  "outright_value",
  "internal_outright",
  "invoice_number",
  "invoice_paid_date",
  "outgoing_awb_number",
  "seller_credit_percent",
  "dim_weight",
  "hazmat_fee",
  "container_fee",
  "release_for_shipment",
  REPAIR_ADMINISTRATION_CHARGE_DOLLARS,
  REPAIR_ADMINISTRATION_CHARGE_PERCENTAGE,
  REPAIR_ADMIN_CHARGE_TYPE,
  "internal_note",
  "external_note",
  "warranty",
  "export_compliance_hold",
  "core_return_awb_number",
  "container_fee",
  "customer_to_return_container",
  "shipped_at"
];

export const LineItemDetail = T.shape({
  id: T.number.isRequired,
  cancellation_reason: T.string,
  condition: T.string.isRequired,
  quantity: T.number.isRequired,
  subtotal: T.string.isRequired,
  internal_note: T.string,
  sell_as_alt: T.shape({
    id: T.number.isRequired,
    part_number: T.string.isRequired
  }),
  inventory: T.shape({
    part: T.shape({
      id: T.number.isRequired,
      part_number: T.string.isRequired
    }).isRequired,
    location: T.string,
    traced_to: T.string,
    tagged_by: T.string
  }).isRequired
});



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/lineItem.js